import React from "react";
import Marquee from "react-fast-marquee";
import { FaCheckCircle, FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
const AboutAreaThree = () => {
  return (
    <>
      {/* =============== About Area Three End ===============*/}
      <div className='about-area bg-gradient-gray pd-top-120 pb-5' id="about-us">
        <div className='container'>
          <div className='row'>
            <div
              className='col-lg-6 '
              data-aos='fade-right'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='about-thumb-inner mb-4 mb-lg-0'>
                <img
                  className='main-img'
                  src='assets/img/about/11.png'
                  alt='img'
                />
              </div>
            </div>
            <div
              className='col-lg-6 wow animated fadeInRight'
              data-aos='fade-left'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='section-title mb-0'>
                <h6 className='sub-title'>ABOUT US</h6>
                <h2 className='title'>
                  Transforming the Way  <span>Vegetable Markets</span> Are Managed
                </h2>
                <p className='content mb-4'>
                Managing a vegetable market business becomes effortless with Aasaann, offering real-time solutions to handle transactions, finances, and relationships with ease.
                </p>
                <div className='row text-nowrap'>
                  <div className='col-md-6'>
                    <ul className='single-list-inner style-check style-heading style-check mb-3'>
                      <li>
                        <FaCheckCircle /> Made for Market Brokers
                      </li>
                      <li>
                        <FaCheckCircle /> Streamlined Operations
                      </li>
                    </ul>
                  </div>
                  <div className='col-md-6'>
                    <ul className='single-list-inner style-check style-heading style-check mb-3'>
                      <li>
                        <FaCheckCircle /> Instant Financial Insights
                      </li>
                      <li>
                        <FaCheckCircle /> Strengthening Key Relationships
                      </li>
                    </ul>
                  </div>
                </div>
                <p className='content'>
                Aasaann removes the complexities of traditional market management, allowing a greater focus on growth while simplifying daily operations. Embrace the future of vegetable market management with greater ease and efficiency.
                </p>
                <Link className='btn btn-border-base' to='/about'>
                  Discover More <FaPlus />
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* =============== About Area Three End ===============*/}
    </>
  );
};

export default AboutAreaThree;
